import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Connects to data-controller="unified-export"
export default class extends Controller {
  static targets = ["selectorsContainer", "cart", "cartSummary", "downloadButton"]
  static values = {
    schemasText: String,
    reportsText: String,
    fieldsText: String,
    attachmentTypesText: String,
    filesText: String,
    templatesText: String
  }

  connect() {
    logger.log("UnifiedExport controller connected")

    // Listen for selectors loaded event
    document.addEventListener('unified-export:selectors-loaded', () => {
      this.updateCart()
    })
  }

  // Load selectors when year is selected
  loadSelectors(event) {
    const yearId = event.target.value

    if (!yearId) {
      this.selectorsContainerTarget.innerHTML = ''
      this.hideCart()
      return
    }

    logger.log("Loading selectors for year:", yearId)

    // Make AJAX request to load selectors (returns HTML)
    fetch(`/developer/unified-exports/load_selectors?year_id=${yearId}`, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      this.selectorsContainerTarget.innerHTML = html
      document.dispatchEvent(new CustomEvent('unified-export:selectors-loaded'))
    })
    .catch(error => {
      console.error('Error loading selectors:', error)
    })
  }

  // Update export cart summary
  updateCart() {
    let schemaCount = 0
    let reportCount = 0
    let fieldCount = 0
    let attachmentTypeCount = 0
    let atFileCount = 0
    let atTemplateCount = 0

    // Count selected schemas and fields
    const schemaCheckboxes = document.querySelectorAll('input[name*="schemas"][name*="[selected]"]:checked')
    schemaCount = schemaCheckboxes.length

    const fieldCheckboxes = document.querySelectorAll('input[name*="schemas"][name*="[fields]"]:checked')
    fieldCount = fieldCheckboxes.length

    // Count selected reports
    const reportCheckboxes = document.querySelectorAll('input[name*="reports["]:checked')
    reportCount = reportCheckboxes.length

    // Count selected attachment types, files, and templates
    const attachmentTypeCheckboxes = document.querySelectorAll('input[name*="attachment_types"][name*="[selected]"]:checked')
    attachmentTypeCount = attachmentTypeCheckboxes.length

    const atFileCheckboxes = document.querySelectorAll('input[name*="attachment_types"][name*="[files]"]:checked')
    atFileCount = atFileCheckboxes.length

    const atTemplateCheckboxes = document.querySelectorAll('input[name*="attachment_types"][name*="[templates]"]:checked')
    atTemplateCount = atTemplateCheckboxes.length

    // Update cart display
    const totalItems = schemaCount + reportCount + attachmentTypeCount

    if (totalItems > 0) {
      this.showCart()

      let summary = '<ul class="mb-0">'
      if (schemaCount > 0) {
        summary += `<li><strong>${schemaCount}</strong> ${this.schemasTextValue} <span class="text-muted">(${fieldCount} ${this.fieldsTextValue})</span></li>`
      }
      if (reportCount > 0) {
        summary += `<li><strong>${reportCount}</strong> ${this.reportsTextValue}</li>`
      }
      if (attachmentTypeCount > 0) {
        const filesText = this.hasFilesTextValue ? this.filesTextValue : 'files'
        const templatesText = this.hasTemplatesTextValue ? this.templatesTextValue : 'templates'
        const attachmentTypesText = this.hasAttachmentTypesTextValue ? this.attachmentTypesTextValue : 'attachment types'
        summary += `<li><strong>${attachmentTypeCount}</strong> ${attachmentTypesText} <span class="text-muted">(${atFileCount} ${filesText}, ${atTemplateCount} ${templatesText})</span></li>`
      }
      summary += '</ul>'

      this.cartSummaryTarget.innerHTML = summary
      this.downloadButtonTarget.disabled = false
    } else {
      this.hideCart()
      this.downloadButtonTarget.disabled = true
    }
  }

  showCart() {
    if (this.hasCartTarget) {
      this.cartTarget.style.display = 'block'
    }
  }

  hideCart() {
    if (this.hasCartTarget) {
      this.cartTarget.style.display = 'none'
    }
  }

  // Auto-select referenced report when a Report template is selected
  autoSelectReport(event) {
    const checkbox = event.target
    const reportId = checkbox.dataset.referencedReportId

    // Only process if checkbox is being checked and has a referenced report
    if (!checkbox.checked || !reportId) {
      return
    }

    // Find the corresponding report checkbox
    const reportCheckbox = document.getElementById(`report_${reportId}`)

    if (reportCheckbox && !reportCheckbox.checked) {
      logger.log(`Auto-selecting report ${reportId} for template dependency`)
      reportCheckbox.checked = true

      // Trigger change event to update cart and hierarchical state
      reportCheckbox.dispatchEvent(new Event('change', { bubbles: true }))

      // Show a visual feedback
      const label = reportCheckbox.nextElementSibling || document.querySelector(`label[for="report_${reportId}"]`)
      if (label) {
        label.classList.add('text-primary', 'fw-bold')
        setTimeout(() => {
          label.classList.remove('text-primary', 'fw-bold')
        }, 1500)
      }
    }
  }
}
